import { z } from 'zod'

export const KanbanCommentSchema = z.object({
  id: z.number(),
  text: z.string(),
  created_at: z.string(),
  profile_id: z.string(),
  files: z.null(),
  product_id: z.string(),
  module_id: z.string(),
  tool_id: z.string()
})

export const KanbanModuleDataSchema = z.object({
  sourceUrl: z.string().url()
})

export const KanbanTaskSchema = z.object({
  id: z.string(),
  title: z.string(),
  description: z.string().optional(),
  data: z.any().optional(),
  extra: z.any().optional(),
  type: z.number(),
  parent: z.string().optional(),
  order: z.number(),
  comments: z.array(KanbanCommentSchema).optional()
})

export const KanbanModuleSchema = z.object({
  id: z.string(),
  title: z.string(),
  description: z.string().optional(),
  data: z.array(KanbanModuleDataSchema).optional(),
  extra: z.object({
    lockFeature: z.boolean().optional(),
    type: z.enum(['dias', 'semanas', 'meses', 'data_especifica', 'Conclusão']).optional(),
    value: z.string().optional(),
    approveRate: z.string().optional()
  }).optional(),
  rows: z.array(KanbanTaskSchema).optional(),
  order: z.number()
})

export const UserInputSchema = z.object({
  id: z.string().optional(),
  tool_id: z.string(),
  data: z.any(),
  extra: z.any().optional()
})

export type KanbanModule = z.infer<typeof KanbanModuleSchema>
export type KanbanTask = z.infer<typeof KanbanTaskSchema>
export type KanbanComment = z.infer<typeof KanbanCommentSchema>
export type UserInput = z.infer<typeof UserInputSchema>
